import { Component } from '@angular/core';
import { LocalStorageService } from '../../services/local-storage.service';
import { ActivatedRoute } from '@angular/router';
import { RouterService } from '../../services/router.service';
import { CourtReservation } from '../../model/court-reservation';
import { User } from '../../model/user';

@Component({
  selector: 'app-confirmation',
  standalone: true,
  imports: [],
  templateUrl: './confirmation.component.html',
  styleUrl: './confirmation.component.css'
})
export class ConfirmationComponent {

  constructor(
              private route: ActivatedRoute, 
              private localStorageService: LocalStorageService,
              private routerService: RouterService
            ) {}
  
  
  type: string = "";
  currentUser!: User;
  users: User[] = [];
  pointsGained: number = 0;
  ranksGained: number = 0;
  
  async ngOnInit(): Promise<void> {
    this.currentUser = await this.localStorageService.getItem("currentUser");
    this.users = await this.localStorageService.getItem("users") || [];
    
    this.route.paramMap.subscribe(async params => {
      this.type = params.get('type') as string;
      if (this.type == "win" || this.type == "loss") {
        this.pointsGained = await this.localStorageService.getItem('matchPoints') || 0;
        await this.localStorageService.remove('matchPoints');
        this.currentUser = await this.localStorageService.getItem("currentUser");
      }

      setTimeout(async () => {
        if (this.type == "booked") {
          await this.routerService.navigateTo('home');
        } else if (this.type == "invite-player") {
          const courtReservation = await this.localStorageService.getItem("courtReservation");
          await this.routerService.navigateTo('book-a-court/' + courtReservation.court_id);
        } else if (this.type == "add-friend") {
          await this.routerService.back();
        } else if (this.type == "win" || this.type == "loss") {
          await this.routerService.navigateTo('home');
        }
      }, 2500)
    });
  }
}
